import * as actionTypes from '../actions/actionTypes';
import { updateObject } from '../utility';

const initialState = {
    fareRules: [],
    intBaggage: [],
    error: false,
    selectedFareRule: null,
    counter: 0,
    baggageCounter: 0,
    success: false,
    fareRulesLoading: true
};

const reducer = (state = initialState, action) => {
    switch(action.type) {
        case actionTypes.SET_FARE_RULES:
            console.log(action.fareRules[0][0]);
            return updateObject(state, {
                fareRules: [
                ...state.fareRules, {
                    id: action.id,
                    rules: action.fareRules[0][0],
                }
            ],
            selectedFareRule: action.fareRules[0][0],
            counter: state.counter + 1,
            fareRulesLoading: false
        })
        case actionTypes.SET_INT_FARE_RULES:
            let success = false;
            if (Number(action.fareRules.fareRules.success) === 1) success = true;
            return updateObject(state, {
                fareRules: [
                ...state.fareRules, {
                    id: action.id,
                    rules: action.fareRules.fareRules.fareRule
                }
            ],
            counter: state.counter + 1,
            success: success,
            fareRulesLoading: false
        })
        case actionTypes.SET_FARE_RULES_LOADING:
            return updateObject(state, {fareRulesLoading: true})
        case actionTypes.GET_FARE_RULES_FAILED:
            return updateObject(state, {error: true})
        case actionTypes.SET_SELECTED_FARE_RULE:
            const selectedFareRule = state.fareRules.find(fareRule => fareRule.id === action.flightId);
            return updateObject(state, { selectedFareRule: selectedFareRule.rules })
        case actionTypes.SET_BAGGAGE_INFO:
            console.log(action);
            return updateObject(state, {
                intBaggage: [
                    ...state.intBaggage, {
                        id: action.id,
                        baggageData: action.baggageData
                    }
                ],
                baggageCounter: state.baggageCounter + 1
            })
        default:
            return state;
    }
}

export default reducer;


// WEBPACK FOOTER //
// ./src/store/reducers/fareRules.js